// REACT
import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router";

// STYLING
import "./edit-list.css";

// ICONS
import { HiPencil } from "react-icons/hi";
import { FiExternalLink } from "react-icons/fi";
import { BsPlusCircleFill } from "react-icons/bs";
import { AiOutlinePushpin, AiFillPushpin } from "react-icons/ai";
import { FaTrashAlt, FaCheck, FaTimes } from "react-icons/fa";

// API & HELPERS
import {
  deleteList,
  getSingleList,
  updateList,
} from "../api-interactions/lists";
import { getFamily, updateFamily } from "../api-interactions/family";
import { updateListShortcuts } from "../api-interactions/appearance";
import { getCookie } from "../helperFunctions/cookie";

// COMPONENTS
import { QuickAdd } from "./quickAdd";
import { Nav } from "./navbar/nav";
import { Backdrop, Switch } from "@material-ui/core";

export const EditList = () => {
  const [list, setList] = useState();
  const [loading, setLoading] = useState(true);
  const [quickAdd, setQuickAdd] = useState(false);
  const [error, setError] = useState(false);
  const [listIsPinned, setListIsPinned] = useState(false);
  const [editSettings, setEditSettings] = useState(false);
  const navigate = useNavigate();

  const { id } = useParams();
  const jwt = getCookie();
  const user = JSON.parse(localStorage.getItem("user"));
  const listShortcuts = JSON.parse(
    localStorage.getItem("appearance")
  ).listShortcuts;

  const getList = async () => {
    setLoading(true);
    try {
      const myList = await getSingleList(jwt, id);
      setList(myList.data.list);
    } catch (e) {
      setError(true);
    }
    setLoading(false);
  };

  useEffect(() => {
    getList();
    listShortcuts.map((shortcut) => {
      if (shortcut.listId === id) setListIsPinned(true);
    });
  }, []);

  const pinHandler = () => {
    setLoading(true);
    let newListShortcuts = listShortcuts;
    if (listIsPinned) {
      newListShortcuts = newListShortcuts.filter((shortcut) => {
        if (shortcut.listId !== id) {
          return true;
        }
        return false;
      });
    } else {
      newListShortcuts.push({
        title: list.title,
        listId: id,
      });
    }
    updateListShortcuts(newListShortcuts, user._id);
    setListIsPinned(!listIsPinned);
    setLoading(false);
  };

  const clickHandler = (accepted, index) => {
    const jwt = getCookie();
    if (accepted) {
      const item = list.needAccept[index];
      // setList((prevState) => {
      //   const newList = prevState.items.push(item);
      //   return newList;
      // });
      list.items.push(item);
    }
    list.needAccept.splice(index, 1);
    updateList(jwt, list._id, list);
    navigate("/dashboard/lists/" + list._id);
  };

  const deleteItemHandler = (itemKey) => {
    const listItems = list.items.filter(function (obj) {
      return obj.key !== itemKey;
    });
    const newList = list;
    newList.items = listItems;
    setList(newList);
    updateList(jwt, list._id, newList);
    navigate("/dashboard/lists/" + newList._id);
  };

  const handleRemoveList = async (id) => {
    if (await deleteList(jwt, id)) {
      navigate("/dashboard/lists");
    }
  };

  const changeHandler = async (e) => {
    const itemId = e.target.id;
    const itemProperties = itemId.split(";");
    itemProperties.push(e.target.checked);

    const earnedPoints = itemProperties[2];

    const newItem = {
      key: itemProperties[0],
      name: itemProperties[1],
      pointComplete: itemProperties[2],
      addedBy: itemProperties[3],
      finished: itemProperties[4],
    };

    list.items = list.items.filter(function (obj) {
      return obj.key !== newItem.key;
    });

    list.items.push(newItem);
    let members = await getFamily(user);
    const specificMember = members.filter((obj) => {
      if (obj.userId === user._id) {
        const index = members.indexOf(obj);
        members.splice(index, 1);
      }
      return obj.userId === user._id;
    });

    if (newItem.finished) {
      specificMember[0].amountOfPoints =
        parseInt(specificMember[0].amountOfPoints) + parseInt(earnedPoints);
    } else {
      specificMember[0].amountOfPoints =
        parseInt(specificMember[0].amountOfPoints) - parseInt(earnedPoints);
    }

    members = [...members, specificMember[0]];
    const newMembers = members;

    updateFamily(jwt, user, { members: newMembers });
    updateList(jwt, list._id, list);
  };

  const updateSettingsHandler = (e) => {
    e.preventDefault();
    const addable = e.target.form[0].checked;
    const permission = e.target.form[1].checked;
    const points = e.target.form[2].checked;

    const newList = {
      addBtn: addable,
      needPermission: permission,
      points,
    };

    updateList(jwt, list._id, newList);
  };

  return (
    <>
      {!loading && !error && (
        <>
          <Nav />
          <div id="edit-list-container">
            <div id="edit-list-list-container">
              <div id="edit-list-header">
                <h2>
                  {list.title}
                  {listIsPinned ? (
                    <AiFillPushpin
                      onClick={pinHandler}
                      className="pushpinIcon"
                    />
                  ) : (
                    <AiOutlinePushpin
                      onClick={pinHandler}
                      className="pushpinIcon"
                    />
                  )}
                </h2>
              </div>
              {(list.addBtn || list.owner === user.email) && (
                <BsPlusCircleFill
                  onClick={() => setQuickAdd(true)}
                  className="add-btn"
                />
              )}
              <div id="edit-list-items">
                <div id="edit-list-items-container">
                  <div id="edit-list-not-completed">
                    <strong>OPEN</strong>
                    {list.items.map((value) => {
                      if (value.finished) return;
                      return (
                        <div className="edit-list-item-container">
                          <div className="edit-list-item-main">
                            <input
                              onChange={changeHandler}
                              defaultChecked={value.finished}
                              id={
                                value.key +
                                ";" +
                                value.name +
                                ";" +
                                value.pointComplete +
                                ";" +
                                value.addedBy
                              }
                              name="taskname"
                              type="checkbox"
                            />
                            <label
                              htmlFor={
                                value.key +
                                ";" +
                                value.name +
                                ";" +
                                value.pointComplete +
                                ";" +
                                value.addedBy
                              }
                              className="edit-list-item-text"
                            >
                              <p>{value.name}</p>
                            </label>
                            <span> - {value.pointComplete} points</span>
                            {value.link && (
                              <a href={"/dashboard/lists/" + value.link}>
                                - list
                              </a>
                            )}
                          </div>
                          <div>
                            <span>{value.addedBy}</span>
                            <FaTrashAlt
                              onClick={() => deleteItemHandler(value.key)}
                              className="delete-item"
                            />
                          </div>
                        </div>
                      );
                    })}
                  </div>
                  <div id="edit-list-proposed">
                    <a href="/dashboard/family/taskmanagment">
                      <strong style={{ color: "#4974DB" }}>
                        PROPOSED <FiExternalLink />
                      </strong>
                    </a>
                    <div>
                      {list.needAccept.map((value, index) => {
                        return (
                          <p className="edit-list-suggestion">
                            <span>{value.addedBy}</span> - {value.name}
                            <div>
                              {value.addedBy !== user.userName && (
                                <FaCheck
                                  id="accept"
                                  onClick={() => clickHandler(true, index)}
                                />
                              )}
                              <FaTimes
                                id="deny"
                                onClick={() => clickHandler(false, index)}
                              />
                            </div>
                          </p>
                        );
                      })}
                    </div>
                  </div>
                  <div id="edit-list-not-completed">
                    <strong style={{ color: "#75A483" }}>COMPLETED</strong>
                    {list.items.map((value) => {
                      if (!value.finished) return;
                      return (
                        <div className="edit-list-item-container">
                          <div className="edit-list-item-main">
                            <input
                              onChange={changeHandler}
                              defaultChecked={value.finished}
                              id={
                                value.key +
                                ";" +
                                value.name +
                                ";" +
                                value.pointComplete +
                                ";" +
                                value.addedBy
                              }
                              name="taskname"
                              type="checkbox"
                            />
                            <label
                              htmlFor={
                                value.key +
                                ";" +
                                value.name +
                                ";" +
                                value.pointComplete +
                                ";" +
                                value.addedBy
                              }
                              className="edit-list-item-text"
                            >
                              <p>{value.name}</p>
                            </label>
                            <span> - {value.pointComplete} points</span>
                            {value.link && (
                              <a href={"/dashboard/lists/" + value.link}>
                                - list
                              </a>
                            )}
                          </div>
                          <div>
                            <span>{value.addedBy}</span>
                            <FaTrashAlt
                              onClick={() => deleteItemHandler(value.key)}
                              className="delete-item"
                            />
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>
            <div id="edit-list-settings-container">
              <h2>
                {editSettings && (
                  <FaTrashAlt
                    onClick={() => handleRemoveList()}
                    className="delete-list"
                  />
                )}
                Settings
                <HiPencil
                  onClick={() => {
                    setEditSettings((prev) => !prev);
                  }}
                  className="edit-list-button hover"
                />
              </h2>
              <p>{list.description}</p>
              <form id="list-properties-form">
                <div>
                  <em>Members can add?</em>
                  <Switch
                    label="points"
                    id="memberCanAdd"
                    defaultChecked={list.addBtn}
                    disabled={!editSettings}
                    color="primary"
                  />
                </div>
                <div>
                  <em>Permission needed?</em>
                  <Switch
                    id="memberCanAdd"
                    defaultChecked={list.needPermission}
                    color="primary"
                    disabled={!editSettings}
                  />
                </div>
                <div>
                  <em>Points?</em>
                  <Switch
                    id="memberCanAdd"
                    defaultChecked={list.points}
                    color="primary"
                    disabled={!editSettings}
                  />
                </div>
                {editSettings && (
                  <div className="edit-settings-btns">
                    <button
                      type="submit"
                      className="update-button"
                      onClick={updateSettingsHandler}
                    >
                      UPDATE
                    </button>
                    <button
                      className="cancel-button"
                      onClick={() => {
                        setEditSettings(false);
                      }}
                    >
                      CANCEL
                    </button>
                  </div>
                )}
              </form>
            </div>
            {quickAdd && (
              <Backdrop open={true} id="full-backdrop">
                <QuickAdd list={list} setQuickAdd={setQuickAdd} />
              </Backdrop>
            )}
          </div>
        </>
      )}
      {error && (
        <>
          <p>The list you requested doesn't exist!</p>
          <button onClick={() => navigate("/dashboard/lists")}>
            Back to lists
          </button>
        </>
      )}
    </>
  );
};
